var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9836 21.42H9.08252",
    stroke: "#0D1444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9836 15.1129H9.08252",
    stroke: "#0D1444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6155 8.82089H9.08252",
    stroke: "#0D1444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2969 1.12897H8.62108C6.77001 1.04248 4.9563 1.62619 3.57371 2.75349C2.19112 3.88079 1.35123 5.46068 1.23645 7.15004C1.21189 7.44565 1.21189 7.74249 1.23645 8.0381V21.8866C1.08118 23.5789 1.66739 25.2583 2.86639 26.5564C4.06539 27.8545 5.77927 28.6652 7.63206 28.8108C7.97777 28.8333 8.32482 28.8333 8.67053 28.8108H21.4453C22.3621 28.8575 23.28 28.7389 24.1465 28.4616C25.0131 28.1842 25.8113 27.7537 26.4955 27.1945C27.1798 26.6354 27.7367 25.9585 28.1344 25.2027C28.5321 24.4469 28.7628 23.627 28.8134 22.7897C28.8381 22.4941 28.8381 22.1973 28.8134 21.9017V8.05316C28.9687 6.36088 28.3825 4.68148 27.1835 3.38338C25.9845 2.08527 24.2706 1.27452 22.4178 1.12897C22.0447 1.10268 21.67 1.10268 21.2969 1.12897V1.12897Z",
    stroke: "#0D1444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.494e9e0068bd3b08d151f3eec3d5c8d4.svg";
export { ForwardRef as ReactComponent };